// extracted by mini-css-extract-plugin
module.exports = {"root":"Page_root__u1HyZ","content":"Page_content__3GpPW","scrollingDisabled":"Page_scrollingDisabled__3RLbs"};